// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import accessTokenService from "../../utils/AccessTokenService";

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptyApi = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: "include",
        prepareHeaders: async (headers) => {
            const token = await accessTokenService.getAccessToken();
            headers.set("Authorization", token ? `Bearer ${token}` : "");
            return headers;
        }
    }),
    tagTypes: ["feedbacks", "history", "workingMemory", "widget-value"],
    endpoints: () => ({})
});
